let entity = "files"
export const GET_ALL =  `${process.env.REACT_APP_URL}${entity}/all`
// export const GET_TYPES =  `${process.env.REACT_APP_URL}${entity}/types`
export const GET =  `${process.env.REACT_APP_URL}${entity}?id=`
// export const REMOVE =  `${process.env.REACT_APP_URL}${entity}?id=`
// export const POST =  `${process.env.REACT_APP_URL}${entity}/`
// export const PUT =  `${process.env.REACT_APP_URL}${entity}/`
// export const PUT_TOGGLE =  `${process.env.REACT_APP_URL}${entity}/type/toggle`
// export const DOWNLOAD =  `${process.env.REACT_APP_URL}${entity}/download`